export class ServiceRequestBase {
  public AuthUser: string | null = null;
  public AuthPwd: string | null = null;
}
